module.exports = __webpack_public_path__ + "img/alueur-candles.6a5517aa.jpg";